import { PageNextIcon } from './PageNextIcon';

/**
 * author: Michael Richins
 * id 760D3DDF-F710-4BE1-A4E6-CC5AD6AF49DB
 * name page-next
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-next.svg
 * tags
 */
export const ReadMoreIcon = PageNextIcon;
export default ReadMoreIcon